import ObjectControlForm from './component'

export default ObjectControlForm
